import CreditCardFormValidation from '../entrypoints/src/admin/components/credit_card_form_validation';
import AjaxLoader from '../entrypoints/src/admin/utilities/ajax-loader';
import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.$btnSave = this.element.querySelector(".btn#save");
    this.bindEvents();
    this.initCreditCardFormValidation();
  }

  bindEvents() {
    $('#payment-profile').on('show.bs.collapse', (ev) => {
      let radio = ev.target.closest('.card').querySelector('input[type="radio"]');
      !!radio && (radio.checked = true);

      this.updateSaveButton();
    });

    this.$btnSave.addEventListener('click', (ev) => {
      ev.preventDefault();
      this.element.querySelector('#payment-method-credit-card').checked && this.formValidation.validate();

      if (this.$btnSave.classList.contains('disabled'))
        return;

      AjaxLoader.show();
      this.$btnSave.closest('form').submit();
    })
  }

  initCreditCardFormValidation() {
    let _this = this;
    let unknownBrand = this.element.querySelector('[data-card-brand="unknown"]');

    this.formValidation = new CreditCardFormValidation(this.element, {
      afterValidate(valid) { _this.updateSaveButton() },
      onCardTypeChanged({type, creditCard}) {
        unknownBrand.classList.toggle('hidden', false);
        _this.element.querySelectorAll(`[data-card-brand]`).forEach((el) => { el.classList.toggle('hidden', true) });

        let brandType = !!type ? type : !!creditCard ? creditCard.card.type : 'unknown',
          brand = _this.element.querySelector(`[data-card-brand="${brandType.replace(/[-]/, '')}"]`);

        if (!brand)
          return true;

        unknownBrand.classList.toggle('hidden', true);
        brand.classList.toggle('hidden', false);
      }
    });
  }

  updateSaveButton() {
    this.$btnSave.classList.toggle('disabled', !this.formValidated);
  }

  get formValidated() {
    let formBankBill = this.element.querySelector('#payment-method-bank-bill');
    return (!!formBankBill && formBankBill.checked) || this.formValidation.isValid;
  }
}